import { createAsyncThunk } from "@reduxjs/toolkit";

import {
    getBrandList as getBrandListApi,
    addBrandList as addBrandListApi,
    updateBrandList as updateBrandListApi,
    deleteBrandList as deleteBrandListApi
} from "../../helpers/helper";
import { toast } from "react-toastify";

export const getBrandList = createAsyncThunk("Brand/getBrandList", async () => {
    try {
        const response = await getBrandListApi();
        return response;
    } catch (error) {
        return error;
    }
});

export const addBrandList = createAsyncThunk("Brand/addBrandList", async (category: any) => {
    try {
        const response = addBrandListApi(category);
        const data = await response;
        toast.success("Brand Added Successfully", { autoClose: 2000 });
        return data;
    } catch (error) {
        toast.error("Brand Added Failed", { autoClose: 2000 });
        return error;
    }
});

export const updateBrandList = createAsyncThunk("Brand/update", async (dataArr: any) => {
    try {
        const response = updateBrandListApi(dataArr);
        const data = await response;
        toast.success("Brand Updated Successfully", { autoClose: 2000 });
        return data;
    } catch (error) {
        toast.error("Brand Updated Failed", { autoClose: 2000 });
        return error;
    }
});

export const deleteBrandList = createAsyncThunk("Brand/deleteBrandList", async (categoryId: any) => {
    try {
        const response = deleteBrandListApi(categoryId);
        console.log(response);
        toast.success("Brand Deleted Successfully", { autoClose: 2000 });
        return categoryId;
    } catch (error) {
        toast.error("Brand Deleted Failed", { autoClose: 2000 });
        return error;
    }
})






